var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Are you sure you want to delete this customer?")]),_c('div',{staticClass:"my-2 py-4 justify-center flex"},[_c('v-btn',{staticClass:"w-1/2",attrs:{"text":""},on:{"click":function($event){return _vm.$emit('closeDialog')}}},[_vm._v("Cancel")]),_c('v-btn',{staticClass:"w-1/2",on:{"click":_vm.confirm}},[_vm._v("Ok")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }